import BForm from "../components/forms/BForm";

function LoginForm({ onSubmit }) {
  const fields = [
    {
      fieldName: "email",
      placeholder: "E-mail",
      validation: {
        required: true,
      },
    },
    {
      fieldName: "password",
      placeholder: "Passwort",
      validation: {
        required: true,
        minLength: {
          value: 2,
          message: "Passwort sollte mindestens 2 Zeichen lang sein",
        },
      },
      type: "password",
    },
  ];

  return <BForm fields={fields} btnText="Einloggen" submit={onSubmit} scroll = ''/>;
}

export default LoginForm;
